// Email Template Service
// Handles loading and processing email templates

export interface TemplateVariables {
    [key: string]: string;
}

// Import templates as raw strings
import userAppointmentPt from '../templates/user-appointment-pt.html?raw';
import userAppointmentEn from '../templates/user-appointment-en.html?raw';
import adminAppointment from '../templates/admin-appointment.html?raw';
import recruitmentAdmin from '../templates/recruitment-admin.html?raw';
import recruitmentUserPt from '../templates/recruitment-user-pt.html?raw';
import recruitmentUserEn from '../templates/recruitment-user-en.html?raw';
import budgetAdmin from '../templates/budget-admin.html?raw';
import budgetUserPt from '../templates/budget-user-pt.html?raw';
import budgetUserEn from '../templates/budget-user-en.html?raw';
import wecallAdmin from '../templates/wecall-admin.html?raw';
import wecallUserPt from '../templates/wecall-user-pt.html?raw';
import wecallUserEn from '../templates/wecall-user-en.html?raw';

const templateCache: { [key: string]: string } = {
    'user-appointment-pt.html': userAppointmentPt,
    'user-appointment-en.html': userAppointmentEn,
    'admin-appointment.html': adminAppointment,
    'recruitment-admin.html': recruitmentAdmin,
    'recruitment-user-pt.html': recruitmentUserPt,
    'recruitment-user-en.html': recruitmentUserEn,
    'budget-admin.html': budgetAdmin,
    'budget-user-pt.html': budgetUserPt,
    'budget-user-en.html': budgetUserEn,
    'wecall-admin.html': wecallAdmin,
    'wecall-user-pt.html': wecallUserPt,
    'wecall-user-en.html': wecallUserEn
};

/**
 * Load an email template from the templates folder
 */
export async function loadEmailTemplate(templateName: string): Promise<string> {
    const template = templateCache[templateName];
    if (!template) {
        throw new Error(`Template ${templateName} not found`);
    }
    return template;
}

/**
 * Replace placeholders in a template with actual values
 */
export function replaceTemplateVariables(template: string, variables: TemplateVariables): string {
    let processedTemplate = template;
    
    for (const [key, value] of Object.entries(variables)) {
        const placeholder = `\\{\\{${key}\\}\\}`;
        // Replace all occurrences
        processedTemplate = processedTemplate.replace(new RegExp(placeholder, 'g'), value || '');
    }
    
    return processedTemplate;
}

/**
 * Process an email template with variables
 */
export async function processEmailTemplate(
    templateName: string,
    variables: TemplateVariables
): Promise<string> {
    const template = await loadEmailTemplate(templateName);
    return replaceTemplateVariables(template, variables);
}

